import { useMemo } from 'react';
import { useI18n } from '../../i18n';
import { translateChat } from '@cubemeet/core/modules/chat/i18n';

/**
 * Web 端 Chat 翻译 Hook
 * 
 * 桥接层：连接 Web 端的 i18n 系统和共享的 Chat 翻译
 */
export const useChatI18n = () => {
  const { language } = useI18n();

  const t = useMemo(() => {
    return (key: string, params?: Record<string, any>) => 
      translateChat(language, key, params);
  }, [language]);

  return { t, language };
};
